<template>
  <v-card class="card-border">
    <v-card-text>
      <v-form ref="form">
        <v-row dense align="center">
          <v-col cols="12" sm="12" md="6">
            <SelectEmpresa :multiple="false" @onChanged="empresa = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="1">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import Parametro from "@/services/parametro"

export default {
  name: "Filtro",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  data() {
    return {
      empresa: '',
      serviceParametro: new Parametro()
    };
  },

  methods: {
    ...mapActions("parametros_empresa", ["setParametros"]),

    async buscar() {
      try {
        if (this.$refs.form.validate()) {
          const response = await this.serviceParametro.getByEmpresa(this.empresa)
          this.setParametros(response)
        }
      } catch (error) {
        this.$toast.error(`Erro ao buscar os dados`);
      }
    }
  }
};
</script>
